<template>
  <div class="design">
    <div class="menu-box">
        <template v-for="(item,index) in tabs">
            <div v-if="!item.is_hidden" :class="['menu-item',{active:cur === item.key}]" :key="`tabKey-${index}-${item.key}`" @click="change_tab(item.key)">
                <img :src="cur === item.key ? require(`@/assets/images/design/icon-${item.key}-active.png`): require(`@/assets/images/design/icon-${item.key}.png`)" alt="" class="icon" /> {{item.title}}
            </div>
        </template>
    </div>
    <div class="content-box">
        <Manuscript v-if="cur === 'manuscript'" />
        <Pat v-if="cur === 'pattern'" />
        <Material v-if="cur === 'material'" @service="showChat" />
        <Accessory v-if="cur === 'accessory'" />
        <OtherFiles v-if="cur === 'other'" />
        <Price v-if="cur === 'price'" />
    </div>

    <div class="footer">
        <div class="btn-box">
            <div class="btn-item submit-btn" @click="save(0)">保存设计</div>
            <div class="btn-item save-btn" v-show="!!uuid" @click="save(1)">去样衣定制</div>
        </div>
    </div>
    <chat ref="chat"></chat>
    <img
      class="show-service"
      src="@/assets/images/chat/zxkf.png"
      @click="showChat"
    />
    <!-- 新增浮窗层 -->
    <div
      v-if="is_lesson_popup_show"
      ref="floatingWindow"
      class="floating-window"
    >
      <div class="floating-header">
        <div>视频教程</div>
        <button class="close-btn" @click="hideLessonPopup">&times;</button>
      </div>
      <div class="floating-body">
        <video
          ref="videoplayer"
          src="https://img.hongli.xingjuju.com/yichuanghub/template/20260414/fd2c0a59410a732971692dbb2d70e0b13ec2a070.mp4"
          poster="https://img.hongli.xingjuju.com/yichuanghub/template/20260414/fd2c0a59410a732971692dbb2d70e0b13ec2a070.mp4?x-oss-process=video/snapshot,t_1000,m_fast"
          class="video"
          controls
          loop
          style="width: 100%; height: 100%"
          @timeupdate="onVideoTimeUpdate"
        >
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </div>
</template>
<script>
import {
  GetDraft,
  ProductCategoryList,
  Profile,
  SaveDraft,
} from "@/api/index.js";
import { mapState } from "vuex";
import Accessory from "./Components/Accessory.vue";
import Manuscript from './Components/Manuscript.vue';
import Material from './Components/Material.vue';
import OtherFiles from './Components/OtherFiles.vue';
import Pat from './Components/Pattern.vue';
import Price from './Components/Price.vue';
export default {
    name: 'WorkbenchDesign',
    components: {
        Manuscript,
        Pat,
        Material,
        Accessory,
        OtherFiles,
        Price
    },
  data() {
    return {
        tabs: [
        { title: "设计稿", key: "manuscript" },
        // { title: "版型选择", key: "pattern" },
        { title: "面料选择", key: "material" },
        { title: "辅料选择", key: "accessory" },
        // { title: "工艺说明", key: "tech" },
        // { title: "印花图", key: "yinhua" },
        // { title: "绣花图", key: "xiuhua" },
        // {title: "商标图", key: 'trademark'},
        // {title: "吊牌图", key: 'label'},
        // {title: "包装图", key: 'package'},
        { title: "其他文件", key: "other" },
        { title: "价格说明", key: "price", is_hidden: false },
        { title: "视频教程", key: "lesson" },
      ],
      cur: "manuscript",
      uuid: "",
      is_click:false,
    };
  },
  beforeUnmount() {
    this.$root.$off('file-data-loaded', this.onFileDataLoaded);
    window.removeEventListener("resize", ($event) =>
      this.handleWindowSize($event)
    );
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$store.commit("design/update_video_current_time", 0);
      vm.$emit("showFooter", false);
      vm.$store.commit("design/clear");
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("design/update_video_current_time", 0);
    this.$emit("showFooter", true);
    next();
  },
  watch: {
    // 监听路由参数的变化
    "$route.query.uuid": {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 更新数据
          this.uuid = newVal;
        }
      },
      immediate: true, // 立即执行一次handler以初始化数据
      deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
    },
    "$store.state.design.is_lesson_popup_show": {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.initDraggable();
            // 设置视频播放时间
            const videoPlayer = this.$refs.videoplayer;
            if (videoPlayer) videoPlayer.currentTime = this.videoCurrentTime;
          });
        }
      },
      immediate: true,
    },
  },
  computed:{
    ...mapState({
      form_data: (state) => state.design.form_data,
      height: (state) => state.design.height,
      videoCurrentTime: (state) => state.design.videoCurrentTime,
      is_lesson_popup_show: (state) => state.design.is_lesson_popup_show,
    }),
  },
  mounted() {
    console.log('[DesignV3ReCoding] mounted - route params file:', this.$route.params.file);
    // 进入页面时先清空 form_data，避免历史 vuex 数据残留
    this.$store.commit("design/clear");
    this.hideLessonPopup();
    this.$store.commit("design/show_lesson");
    this.$root.$on('file-data-loaded', this.onFileDataLoaded);
    this.$nextTick(() => {
      this.handleWindowSize();
    });
    window.addEventListener("resize", (e) => {
      this.handleWindowSize(e);
    });
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
    }
    if (this.$route.query.price) {
      this.cur = "price";
    }
    this.$Spin.show();
    Promise.all([
      this.getProductCategoryList(),
      this.uuid ? GetDraft({ uuid: this.uuid }) : Promise.resolve(null),
    ]).then(([response1, response2]) => {
        if (response2 && response2.code > 0) {
          return;
        }
        if (response2) {
          this.$store.commit("design/init", { design: response2.data });
        }
      }).then(() => {
        const { file } = this.$route.params;
        console.log('[DesignV3ReCoding] 初始化完成, route file:', file?.type, 'cur:', this.cur);
        if (file && file.type === '51') {
          console.log('[DesignV3ReCoding] change_tab -> manuscript');
          this.change_tab('manuscript');
        } else if (file && file.type === '52') {
          console.log('[DesignV3ReCoding] change_tab -> material');
          this.change_tab('material');
        } else if (file && file.type === '53') {
          console.log('[DesignV3ReCoding] change_tab -> accessory');
          this.change_tab('accessory');
        }
      }).finally(() => {
        const { file } = this.$route.params;
        if (!file || !['51','52','53'].includes(file.type)) {
          console.log('[DesignV3ReCoding] 无待处理文件, 直接隐藏Spin');
          this.$Spin.hide();
        } else {
          console.log('[DesignV3ReCoding] 有待处理文件(type:', file.type, '), Spin由子组件关闭');
        }
      });
  },
  methods: {
    onFileDataLoaded() {
      this.$Spin.hide();
    },
    hideLessonPopup() {
      // 保存当前视频播放时间
      if (this.$refs.videoplayer) {
        this.$store.commit(
          "design/update_video_current_time",
          this.$refs.videoplayer.currentTime
        );
      }
      this.$store.commit("design/hide_lesson_popup");
    },
    onVideoTimeUpdate() {
      // 更新视频播放时间
      if (this.$refs.videoplayer) {
        this.$store.commit(
          "design/update_video_current_time",
          this.$refs.videoplayer.currentTime
        );
      }
    },
    initDraggable() {
      const win = this.$refs.floatingWindow;
      if (!win) return;

      let isDragging = false;
      let startX, startY;
      let initialX, initialY;

      const startDrag = (e) => {
        isDragging = true;

        const rect = win.getBoundingClientRect();
        initialX = rect.left;
        initialY = rect.top;

        startX = e.pageX;
        startY = e.pageY;

        document.addEventListener("mousemove", onDrag);
        document.addEventListener("mouseup", stopDrag);
      };

      const onDrag = (e) => {
        if (!isDragging) return;

        const dx = e.pageX - startX;
        const dy = e.pageY - startY;

        const newX = initialX + dx;
        const newY = initialY + dy;

        win.style.left = `${newX}px`;
        win.style.top = `${newY}px`;
      };

      const stopDrag = () => {
        isDragging = false;
        document.removeEventListener("mousemove", onDrag);
        document.removeEventListener("mouseup", stopDrag);
      };

      // 清除之前的事件监听器，防止重复绑定
      const header = win.querySelector(".floating-header");
      if (header && !header._dragInitialized) {
        header.addEventListener("mousedown", startDrag);
        header._dragInitialized = true; // 防止重复初始化
      }
    },
    change_tab(cur) {
      if (cur === "lesson") {
        // if (this.cur === "manuscript") {
        //   return;
        // }
        // 修复视频浮窗显示问题：无论当前在哪个tab，点击视频教程都应该显示浮窗
        this.$store.commit("design/show_lesson_popup"); // 显示浮窗
      } else if (
        ["manuscript", "trademark", "label", "package", "other"].includes(cur)
      ) {
        this.hideLessonPopup();
        this.$store.commit("design/show_lesson");
        this.cur = cur;
      } else {
        this.$store.commit("design/hide_lesson");
        this.cur = cur;
      }
    },
    showChat() {
      if (!this.uuid) {
        return this.$refs["chat"].showChat();
      }
      let design = {
        uuid: this.uuid,
        image: this.form_data.image,
        name: this.form_data.name,
        from: "draft",
      };
      this.$refs["chat"].showChat(design);
    },
    showChatIcon() {
      this.show = true;
    },
    open_window(path) {
      window.open(path, "_blank");
    },
    save(redirect) {
      if (this.is_click) {
        return;
      }
      // 数据预处理
      if (this.form_data.material_self.length > 0) {
        this.$store.commit("design/update_common", {
          key: "is_material_self",
          value: 1,
        });
      } else {
        this.$store.commit("design/update_common", {
          key: "is_material_self",
          value: 0,
        });
      }
      if (this.form_data.accessory_self.length > 0) {
        this.$store.commit("design/update_common", {
          key: "is_accessory_self",
          value: 1,
        });
      } else {
        this.$store.commit("design/update_common", {
          key: "is_accessory_self",
          value: 0,
        });
      }
      if (this.form_data.material_daigou.length > 0) {
        this.$store.commit("design/update_common", {
          key: "is_material_daigou",
          value: 1,
        });
      } else {
        this.$store.commit("design/update_common", {
          key: "is_material_daigou",
          value: 0,
        });
      }
      if (this.form_data.accessory_daigou.length > 0) {
        this.$store.commit("design/update_common", {
          key: "is_accessory_daigou",
          value: 1,
        });
      } else {
        this.$store.commit("design/update_common", {
          key: "is_accessory_daigou",
          value: 0,
        });
      }
      console.log("form-data", this.form_data);
      // return;
      this.is_click = true;
      SaveDraft({
        ...this.form_data,
        uuid: this.uuid,
        scene: redirect ? "dz" : "bc",
      })
        .then((response) => {
          this.$layer.msg(`操作成功`);
          if (!redirect && !this.uuid) {
            this.$router.replace({
              name: "WorkBenchDesign",
              query: { uuid: response.data.uuid },
            });
          }
          if (redirect) {
            this.$router.push({
              name: "WorkBenchSummary",
              query: { uuid: response.data.uuid, from: "draft" },
            });
          }
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          setTimeout(() => {
            this.is_click = false;
          }, 500);
        });
    },
    async getProductCategoryList() {
      return ProductCategoryList().then((response) => {
        this.$store.commit("design/set_product_category_list", response.data);
        return response;
      });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    handleWindowSize(e) {
      console.log("resize", e);
      this.$store.commit(
        "design/set_height",
        window.innerHeight - 90 - 72 + 20 + "px"
      );
      this.width = window.innerWidth - 225 + "px";
    },
  },
};
</script>
<style lang="scss" scoped>
.design {
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  background: transparent;
  .menu-box{
    position:sticky;
    top:80px;
    width:220px;
    height:calc(100% - 60px);
    flex-shrink:0;
    background:#fff;
    overflow-y:auto;
    padding:20px 10px 80px 60px;
    display:flex;
    flex-direction: column;
    row-gap:10px;
    border-right:1px solid #f0f0f0;
    .menu-item{
        display:flex;
        align-items:center;
        cursor: pointer;
        column-gap:13px;
        color:#333;
        font-size:16px;
        padding:5px 29px 5px 17px;
        border-radius:5px;
        &.active{
            color:#fff;
            background:#000;
        }
        img{
            width:20px;
            height:20px;
        }
        &:nth-last-child(2){
            border-top:1px solid #f0f0f0;
        }
    }
  }
  .content-box{
    flex:1;
    height:calc(100% - 60px);
    background:rgb(248,249,252);
    overflow:auto;
  }

  .footer{
    width:100%;
    height:60px;
    border-top:1px solid #e2e5e9;
    display:flex;
    align-items:center;
    justify-content:center;
    position:fixed;
    bottom:0;
    left:0;
    background:#fff;
    .btn-box{
        display:flex;
        align-items:center;
        justify-content:center;
        column-gap:10px;
        .btn-item{
            font-size:14px;
            padding:8px 41px;
            cursor:pointer;
            border-radius:19px;
            &.save-btn{
                background:#ebebeb;
                color:#1c1f23;
            }
            &.submit-btn{
                color:#fff;
                background:#1c1f23;
            }
        }
    }
  }
}

.show-service {
    position: fixed;
    top: 200px;
    width: 55px;
    height: 160px;
    right: 0;
}

.floating-window {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 640px;
  max-width: 90vw;
  height: 420px; // 固定高度避免变形
  // min-height:200px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  user-select: none;
}

.floating-header {
  padding: 5px 15px;
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
  font-weight: bold;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.floating-body {
  padding: 10px;
  height: calc(100% - 40px); // 标题栏占 40px
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

::v-deep .ivu-page{
  margin-bottom:0 !important;
}
</style>
